/* eslint-disable no-console */
// import { configureStore } from "@reduxjs/toolkit";
// import userReducer from './slices/userSlice';
// import townshipReducer, { TownshipState } from './slices/townshipSlice'
// import currentPermitReducer, { CurrentPermitState } from './slices/currentPermitSlice'
// import navigationReducer, { NavigationState } from './slices/navigationSlice'

// export interface UserDetails {
//     [key: string]: any;
// }

// export interface RootState {
//     user: {
//         userDetails: UserDetails;
//     };
//     township: TownshipState;
//     currentPermit: CurrentPermitState;
//     navigation: NavigationState
// }

// const appStore = configureStore({
//     reducer: {
//         user: userReducer,
//         township: townshipReducer,
//         currentPermit: currentPermitReducer,
//         navigation: navigationReducer
//     },
// });

// export default appStore;

import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer, PersistConfig } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage
import userReducer from './slices/userSlice';
import encryptDecryptTransform from './obfuscateTransform';
import themeReducer, { ThemeState } from './slices/themeSlice';
import logoutReducer, { LogoutState } from './slices/logoutSlice';

export interface UserDetails {
  [key: string]: any;
}

export interface RootState {
  user: {
    userDetails: UserDetails;
  };
  socket: any;
  cart: any;
  theme: ThemeState;
  logout: LogoutState;
}

// Combine the reducers properly
const rootReducer = combineReducers({
  user: userReducer,
  theme: themeReducer,
  logout: logoutReducer
});

// Redux Persist configuration
const persistConfig: PersistConfig<RootState> = {
  key: 'root', // Key to store the state in localStorage
  storage, // Use localStorage or sessionStorage
  whitelist: [
    'user',
    'township',
    'currentPermit',
    'navigation',
    'theme',
    'error',
    'socket',
    'cart'
  ], // Define which slices to persist
  transforms: [encryptDecryptTransform]
};

// Apply persistReducer to the root reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

const appStore = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false // Disable serializable checks for persist
    })
});

const persistor = persistStore(appStore); // Create persistor for rehydration

export { appStore, persistor };
